module.exports = __webpack_public_path__ + "static/lathander-symbol-DND3_FnP-edc8176adef3df4de2bbdb9c203fab5a.webp";